import { useParams } from "react-router-dom";
import { useSimulatorConfiguration } from "./useSimulatorConfiguration";
import { ConfigurationViewGuard } from "./parts/ConfigurationViewGuard";
import { TicketChannelGeneralConfiguration } from "./ticket-channel/TicketChannelGeneralConfiguration";
import { QuackchatChannelGeneralConfiguration } from "./quackchat-channel/QuackchatChannelGeneralConfiguration";
import { CopilotChannelGeneralConfiguration } from "./copilot-channel/CopilotChannelGeneralConfiguration";
import { SlackChannelGeneralConfiguration } from "./slack-channel/SlackChannelGeneralConfiguration";

export function GeneralConfiguration() {
  const { simulatorId } = useParams();
  const { simulator } = useSimulatorConfiguration(simulatorId);

  const channel = simulator?.channel;

  return (
    <ConfigurationViewGuard view={"general"}>
      {channel === "autonomous_ticket_event" && (
        <TicketChannelGeneralConfiguration />
      )}

      {channel === "autonomous_quackchat" && (
        <QuackchatChannelGeneralConfiguration simulatorId={simulatorId} />
      )}
      {channel === "copilot" && <CopilotChannelGeneralConfiguration />}
      {channel === "slackbot" && <SlackChannelGeneralConfiguration />}
    </ConfigurationViewGuard>
  );
}
